const initKonamiManager = async () => {
    const {default: Konami} = await import('konami');
    new Konami(cornify);
};

const cornify = async () => {
    const cornifyUrl = 'https://cornify.com/js/cornify';
    const extension = ['.js', '_run.js'];
    let cornifyNodes = document.getElementById('__cornify_nodes');

    if (cornifyNodes) {
        cornifyUrl.cornify_add();
    } else {
        let div = document.createElement('div');
        div.id = '__cornify_nodes';
        document.getElementsByTagName('body')[0].appendChild(div);
        for (let l = 0; l < extension.length; l++) {
            cornifyNodes = document.createElement('script');
            cornifyNodes.src = cornifyUrl + extension[l];
            div.appendChild(cornifyNodes);
        }
    }
};

export default class KonamiManager {
    static init() {
        initKonamiManager();
    }
}
